<template>
  <div class="container-page">
    <div class="app">
      <OnboardingPreinscription
        v-on:getPreinscriptionEmit="getPreinscription"
        v-if="showOnboarding === true && !isPaiementEnLigne"
        :token="token_out"
        :captchaInfo="captchaInfo"
        :instructionsCaptcha="instructionsCaptcha"
        :serverError="serverError"
      />
      <FormulairePreinscription
        v-if="showOnboarding === false && !isPaiementEnLigne"
        :preinscription="preinscription"
        :token="token_out"
      />
      <RemerciementsPreinscription
        v-if="isPaiementEnLigne"
        :token="token_out"
      />
    </div>
    <div
      v-if="showOnboarding === true && !isPaiementEnLigne"
      class="onboarding-footer"
    >
      <a
        class="onboarding-info mr-1"
        href="http://www.ffbb.com/ffbb/politique-de-protection-des-donnees-personnelles"
        target="_blank"
      >
        {{ "onboarding_politique" | translate("fr") }}
      </a>
      <span class="onboarding-info-extra"> et </span>
      <a
        class="onboarding-info ml-1"
        @click="$bvModal.show('modal-mentions-legales')"
      >
        {{ "onboarding_mentions" | translate("fr") }}</a
      >
      <p class="captcha-instructions">
        {{ "onboarding_copyright" | translate("fr") }}
      </p>
    </div>

    <b-modal centered id="modal-mentions-legales" ref="modal-mentions-legales">
      <p class="mentions-legales-titre mb-4">
        {{ "mentions_legales_titre" | translate("fr") }}
      </p>
      <p class="mentions-legales-texte">
        <span
          v-html="$options.filters.translate('mentions_legales_texte', 'fr')"
        ></span>
      </p>

      <template v-slot:modal-title>
        <div></div>
      </template>

      <template v-slot:modal-footer>
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import translations from "@/Translations.js";
import OnboardingPreinscription from "@/components/OnboardingPreinscription.vue";
import FormulairePreinscription from "@/components/FormulairePreinscription.vue";
import RemerciementsPreinscription from "@/components/RemerciementsPreinscription.vue";

import preinscriptionAppelsServeur from "@/preinscriptionUtils";

export default {
  name: "app",
  components: {
    OnboardingPreinscription,
    FormulairePreinscription,
    RemerciementsPreinscription
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  data() {
    return {
      preinscription: null,
      token_out: undefined,
      captchaInfo: undefined,
      instructionsCaptcha: undefined,
      showOnboarding: true,
      serverError: null,
      erreurGlobale: null // valorisée dans traitementErreursServeur
    };
  },
  methods: {
    // Triggered when 'getPreinscriptionEmit' event is emitted by the child.
    getPreinscription(preinscription) {
      this.preinscription = preinscription;
      this.showOnboarding = false;
    },
    getCaptcha(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getCaptcha(that.token_out)
        .then(captchaInfo => {
          that.captchaInfo = captchaInfo;
        })
        .catch(error => {
          if (error.response) {
            // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
            var argsArray = [];
            preinscriptionAppelsServeur.traitementErreursServeur(
              error,
              isReconnected,
              that,
              that.getCaptcha,
              argsArray
            );
            that.serverError = that.erreurGlobale;
          } else {
            that.serverError =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
          }
        });
    },
    getInstructionsCaptcha(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getInstructionsCaptcha(that.token_out)
        .then(instructionsCaptcha => {
          that.instructionsCaptcha = instructionsCaptcha;
        })
        .catch(error => {
          if (error.response) {
            // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
            var argsArray = [];
            preinscriptionAppelsServeur.traitementErreursServeur(
              error,
              isReconnected,
              that,
              that.getInstructionsCaptcha,
              argsArray
            );
            that.serverError = that.erreurGlobale;
          } else {
            that.serverError =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
          }
        });
    },
    verifierPreinscription() {
      var that = this;
      // si l'utilisateur a eu son captcha déjà vérifié dans l'heure on ne souhaite pas lui redemander son captcha
      preinscriptionAppelsServeur
        .getPreinscription(that.token_out, "", "")
        .then(result => {
          if (!result.data) {
            that.getCaptcha(false /*isReconnected*/);
            that.getInstructionsCaptcha(false /*isReconnected*/);
          }
        })
        .catch(error => {
          if (error.response && error.response.status !== 401) {
            that.getCaptcha(false /*isReconnected*/);
            that.getInstructionsCaptcha(false /*isReconnected*/);
          } else {
            that.serverError =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
          }
        });
    },
    getAuthenticationToken(isReconnected) {
      var that = this;
      // verifie si l'id d'authentification. La non possibilité de s'identifier doit retourner un message d'erreur
      preinscriptionAppelsServeur
        .getAuthenticationToken(this.$route.query.id)
        .then(result => {
          that.token_out = result;
          if (that.token_out != null) {
            that.verifierPreinscription();
          }
        })
        .catch(error => {
          if (error.response) {
            // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
            var argsArray = [];
            preinscriptionAppelsServeur.traitementErreursServeur(
              error,
              isReconnected,
              that,
              that.getAuthenticationToken,
              argsArray
            );
          } else {
            that.serverError =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
          }
        });
    }
  },
  computed: {
    isPaiementEnLigne() {
      return this.$route.fullPath.indexOf("checkoutIntentId") > -1;
    }
  },
  mounted: function() {
    this.getAuthenticationToken(false /*isReconnected*/);
  }
};
</script>
<style scoped>
.onboarding-info,
.onboarding-info:hover {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}

.onboarding-info-extra {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #fff;
}

.container-page {
  display: table;
  width: 100%;
  height: 100%;
}

.onboarding-footer {
  bottom: 0;
  width: 100%;
  display: table-footer-group;
  text-align: center;
}

.mentions-legales-titre {
  font-family: Lato;
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  color: #000;
}

.mentions-legales-texte {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  line-height: 27px;
  color: #000;
  margin-left: 20px;
  margin-right: 20px;
}

/* mobile phone */
@media (max-width: 480px) {
  .mentions-legales-texte {
    font-size: 13px;
  }

  .mentions-legales-titre {
    font-size: 16px;
  }
}
</style>
